export default {
  main: '#2e588a',
  dark: '#092341',
  disabled: '#b3cce8',
  bgcolor: '#f2f7ff',
  fill: '#C0D0E3',
  aludark: '#383E42',
  bluemid: '#084893',
};
